/* Tab (Oct 30, Mordy 9:45 AM): discount code field in the cart page + cart drawer.
   The customer types the code; Shopify's cart stores it (POST /cart/update.js {discount}),
   so it carries into checkout. Markup: snippets/tab-cart-discount.liquid. */
(function () {
  if (window.__tabCartDiscount) return;
  window.__tabCartDiscount = true;

  var cartRoot = (window.routes && window.routes.cart_url) || '/cart';
  var updateUrl = (window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : cartRoot + '/update') + '.js';
  updateUrl = updateUrl.replace(/\.js\.js$/, '.js');


  // ™ small + superscript after cart re-renders (same rule as tab-edits.js, which only runs at page load)
  function supTM(root) {
    if (!root) return;
    var skip = /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT|OPTION|SELECT|SUP|TITLE)$/;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode: function (n) {
      if (n.nodeValue.indexOf('\u2122') === -1) return NodeFilter.FILTER_REJECT;
      for (var p = n.parentNode; p && p !== root.parentNode; p = p.parentNode) if (p.nodeType === 1 && skip.test(p.tagName)) return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT; } });
    var nodes = []; while (w.nextNode()) nodes.push(w.currentNode);
    nodes.forEach(function (n) {
      var parts = n.nodeValue.split('\u2122'), frag = document.createDocumentFragment();
      parts.forEach(function (t, i) { if (t) frag.appendChild(document.createTextNode(t));
        if (i < parts.length - 1) { var s = document.createElement('sup'); s.className = 'tab-tm'; s.textContent = '\u2122'; frag.appendChild(s); } });
      n.parentNode.replaceChild(frag, n);
    });
  }
  function watchTM() {
    ['CartDrawer', 'main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var el = document.getElementById(id); if (!el || el.__tabTM) return; el.__tabTM = true;
      new MutationObserver(function () { supTM(el); }).observe(el, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchTM); else watchTM();

  function sectionsToRender() {
    var s = [];
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (items && items.dataset.id) s.push(items.dataset.id);
    if (footer && footer.dataset.id) s.push(footer.dataset.id);
    if (document.querySelector('cart-drawer')) s.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) s.push('cart-icon-bubble');
    return s;
  }

  function swap(html, sel, targetSel) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var src = doc.querySelector(sel);
    var dst = document.querySelector(targetSel || sel);
    if (src && dst) dst.innerHTML = src.innerHTML;
  }

  function render(sections) {
    if (!sections) return;
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (items && sections[items.dataset.id]) swap(sections[items.dataset.id], '.js-contents', '#main-cart-items .js-contents');
    if (footer && sections[footer.dataset.id]) swap(sections[footer.dataset.id], '.js-contents', '#main-cart-footer .js-contents');
    if (sections['cart-drawer']) swap(sections['cart-drawer'], '#CartDrawer .drawer__inner', '#CartDrawer .drawer__inner');
    if (sections['cart-icon-bubble']) swap(sections['cart-icon-bubble'], '.shopify-section', '#cart-icon-bubble');
  }

  function post(codes, withSections) {
    var body = { discount: codes.join(',') };
    if (withSections) body.sections = sectionsToRender();
    return fetch(updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }

  function currentCodes() {
    return fetch(cartRoot + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { return (c.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; }); });
  }

  function showError(box, msg) {
    var e = box && box.querySelector('.tab-discount__error');
    if (!e) return;
    e.textContent = msg; e.hidden = !msg;
    box.classList.toggle('tab-discount--error', !!msg);
  }

  function refocus(ctx) {
    var i = document.getElementById('TabDiscount-' + ctx);
    if (i && ctx === 'page') i.blur();
  }

  function apply(box) {
    var input = box.querySelector('.tab-discount__input');
    var btn = box.querySelector('[data-tab-discount-apply]');
    var code = (input.value || '').trim().toUpperCase();
    if (!code) { showError(box, 'Enter a discount code.'); input.focus(); return; }
    showError(box, '');
    btn.disabled = true; box.classList.add('tab-discount--busy');
    var ctx = box.dataset.ctx;
    currentCodes().then(function (prev) {
      if (prev.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) {
        throw { user: '\u201C' + code.toUpperCase() + '\u201D is already applied.' };
      }
      return post(prev.concat([code]), true).then(function (cart) {
        var hit = (cart.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
        if (!hit || !hit.applicable) {
          // undo the bad code, keep the cart as it was
          return post(prev, false).then(function () {
            throw { user: prev.length
              ? '\u201C' + code.toUpperCase() + '\u201D can\u2019t be combined with ' + prev.join(', ') + '.'
              : '\u201C' + code.toUpperCase() + '\u201D isn\u2019t a valid code.' };
          });
        }
        render(cart.sections);
        refocus(ctx);
        document.dispatchEvent(new CustomEvent('tab:discount', { detail: { applied: code } }));
      });
    }).catch(function (err) {
      var b = document.querySelector('[data-tab-discount][data-ctx="' + ctx + '"]') || box;
      showError(b, err && err.user ? err.user : 'Something went wrong. Please try again.');
      var i = b.querySelector('.tab-discount__input'); if (i && !i.value) i.value = code;
    }).then(function () {
      var b = document.querySelector('[data-tab-discount][data-ctx="' + ctx + '"]') || box;
      var bb = b.querySelector('[data-tab-discount-apply]'); if (bb) bb.disabled = false;
      b.classList.remove('tab-discount--busy');
    });
  }

  function remove(box, code) {
    box.classList.add('tab-discount--busy');
    currentCodes().then(function (prev) {
      var rest = prev.filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
      return post(rest, true);
    }).then(function (cart) { render(cart.sections); })
      .catch(function () { showError(box, 'Couldn\u2019t remove the code. Please try again.'); box.classList.remove('tab-discount--busy'); });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-tab-discount-apply]');
    if (a) { e.preventDefault(); apply(a.closest('[data-tab-discount]')); return; }
    var r = e.target.closest('[data-tab-discount-remove]');
    if (r) { e.preventDefault(); remove(r.closest('[data-tab-discount]'), r.getAttribute('data-tab-discount-remove')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var i = e.target.closest && e.target.closest('.tab-discount__input');
    if (!i) return;
    e.preventDefault();
    apply(i.closest('[data-tab-discount]'));
  });
  document.addEventListener('input', function (e) {
    var i = e.target.closest && e.target.closest('.tab-discount__input');
    if (i) showError(i.closest('[data-tab-discount]'), '');
  });
})();
